import React from "react";
import PropTypes from "prop-types";

function SadFace({ className, style, fill, defaultWidth, defaultHeight }) {
  return (
    <svg
      viewBox="0 0 140 140"
      width={style && style.width ? style.width : defaultWidth}
      height={style && style.width ? style.height : defaultHeight}
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill={fill} fill-rule="nonzero">
        <path d="M70 0C31.402609 0 0 31.402609 0 70s31.402609 70 70 70c38.600435 0 70-31.402609 70-70S108.600435 0 70 0zm0 133.913043c-35.243478 0-63.913043-28.669565-63.913043-63.913043S34.756522 6.086957 70 6.086957c35.240435 0 63.913043 28.669565 63.913043 63.913043S105.240435 133.913043 70 133.913043z" />
        <path d="M54 58c0-4.962-4.038-9-9-9s-9 4.038-9 9 4.038 9 9 9 9-4.038 9-9zm-12 0c0-1.653 1.347-3 3-3s3 1.347 3 3-1.347 3-3 3-3-1.347-3-3zM95 49c-4.962 0-9 4.038-9 9s4.038 9 9 9 9-4.038 9-9-4.038-9-9-9zm0 12c-1.656 0-3-1.347-3-3s1.344-3 3-3 3 1.347 3 3-1.344 3-3 3zM70.5 86c-11.370786 0-22.204754 4.736952-29.72326 12.998869-1.122437 1.235987-1.015684 3.131968.237909 4.235957 1.256642 1.106989 3.184308.99899 4.306746-.233998C51.683911 96.007899 60.861673 91.999939 70.5 91.999939s18.816089 4.00796 25.178605 11.000889c.60087.662994 1.436599.99899 2.272327.99899.722875 0 1.4549-.251997 2.03442-.764992 1.253592-1.103989 1.360345-2.99997.237907-4.235957C92.704754 90.739952 81.873836 86 70.5 86z" />
      </g>
    </svg>
  );
}

SadFace.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  fill: PropTypes.string
};

SadFace.defaultProps = {
  className: undefined,
  defaultHeight: 140,
  defaultWidth: 140,
  fill: "#D2E3E4"
};

export default SadFace;
